<template>
  <v-container>
    <v-row justify="space-between" dense>
      <v-row align="start" justify="center">
        <v-col cols="12">
          <v-card class="elevation-2">
            <title-bar></title-bar>
            <v-card-title class="primary--text text-h6 pl-4 font-weight-bold"
              >AVAILABILITY</v-card-title
            >
            <v-card-text>
              <v-form ref="form" v-model="valid" lazy-validation>
                <v-row>
                  <v-col cols="12" md="3">
                    <v-text-field
                      v-model="avail.sun"
                      label="Sunday *"
                      prepend-inner-icon="mdi-calendar-clock"
                      placeholder="Anytime 5am-11pm"
                      :rules="requiredRules"
                      filled
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field
                      v-model="avail['mon']"
                      label="Monday *"
                      prepend-inner-icon="mdi-calendar-clock"
                      placeholder="Anytime 5am-11pm"
                      :rules="requiredRules"
                      filled
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field
                      v-model="avail['tue']"
                      label="Tuesday *"
                      prepend-inner-icon="mdi-calendar-clock"
                      placeholder="Anytime 5am-11pm"
                      :rules="requiredRules"
                      filled
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field
                      v-model="avail['wed']"
                      label="Wednesday *"
                      prepend-inner-icon="mdi-calendar-clock"
                      placeholder="Anytime 5am-11pm"
                      :rules="requiredRules"
                      filled
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field
                      v-model="avail['thu']"
                      label="Thursday *"
                      prepend-inner-icon="mdi-calendar-clock"
                      placeholder="Anytime 5am-11pm"
                      :rules="requiredRules"
                      filled
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field
                      v-model="avail['fri']"
                      label="Friday *"
                      prepend-inner-icon="mdi-calendar-clock"
                      placeholder="Anytime 5am-11pm"
                      :rules="requiredRules"
                      filled
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field
                      v-model="avail['sat']"
                      label="Saturday *"
                      prepend-inner-icon="mdi-calendar-clock"
                      placeholder="Anytime 5am-11pm"
                      :rules="requiredRules"
                      filled
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="12">
                    <v-checkbox
                      v-model="avail['overnight']"
                      label="I am available for graveyard/overnight shifts."
                    ></v-checkbox>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" lg="6">
                    <div class="heading">
                      If hired, when would you be able to start?
                    </div>
                    <v-date-picker
                      v-model="avail['start_date']"
                      full-width
                      :landscape="$vuetify.breakpoint.smAndUp"
                      class="mt-4"
                    ></v-date-picker>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn color="secondary" @click="previous">Previous</v-btn>
              <v-btn class="mr-5" color="primary" @click="formSubmit"
                >Next</v-btn
              >
            </v-card-actions>
            <footer-bar></footer-bar>
          </v-card>
        </v-col>
      </v-row>
    </v-row>
  </v-container>
</template>

<script>
import TitleBar from "../components/TitleBar";
import FooterBar from "../components/Footer";

export default {
  components: { TitleBar, FooterBar },

  computed: {
    avail: {
      get() {
        return this.$store.state.avail;
      },
      set(value) {
        this.$store.commit("setAvail", { avail: value });
      },
    },
    app_state: {
      get() {
        return this.$store.state;
      },
    },
  },

  data: () => ({
    valid: false,
    requiredRules: [(v) => !!v || "This field is required"],
  }),
  props: {
    source: String,
  },

  methods: {
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${month}/${day}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    updateAvail(e) {
      this.$store.commit("setAvail", e.target.value);
    },

    formSubmit(e) {
      console.log(e);
      console.log(JSON.parse(JSON.stringify(this.$store.state)));
      e.preventDefault();
      if (this.$refs.form.validate()) {
        this.$router.push({ name: "P3" });
      }
    },
    previous(e) {
      e.preventDefault();
      this.$router.push({ name: "P1" });
    },
  },

  /* beforeRouteLeave (to, from , next) {
    const answer = window.confirm('Do you really want to leave? you have unsaved changes!')
    if (answer) {
      next()
    } else {
      next(false)
    }
  }*/
};
</script>
